import { Head } from '@inertiajs/react'

type RouteBoundaries = {
  admin: string
  app: string
  api: string
}

type Clients = {
  admin: string
  app: string
  api: string
}

type Props = {
  route_boundaries: RouteBoundaries
  clients: Clients
}

export default function Index({ route_boundaries, clients }: Props) {
  return (
    <>
      <Head title="Admin" />

      <section className="space-y-8">
        <div className="space-y-3">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-sky-300">Rails deployment unit</p>
          <h2 className="text-3xl font-semibold">Route boundaries are explicit.</h2>
          <p className="max-w-3xl text-slate-300">
            The admin back-office runs through Rails + Inertia, the customer app stays isolated at
            <code className="mx-1 rounded bg-slate-800 px-2 py-1 text-slate-100">/app</code>, and customer clients consume JSON under
            <code className="mx-1 rounded bg-slate-800 px-2 py-1 text-slate-100">/api/v1</code>.
          </p>
        </div>

        <div className="grid gap-4 md:grid-cols-3">
          {Object.entries(route_boundaries).map(([key, value]) => (
            <article key={key} className="rounded-2xl border border-slate-800 bg-slate-900 p-5 shadow-sm shadow-black/20">
              <p className="text-sm font-semibold uppercase tracking-wide text-sky-300">{key}</p>
              <p className="mt-2 font-mono text-sm text-slate-100">{value}</p>
              <p className="mt-3 text-sm text-slate-300">{clients[key as keyof Clients]}</p>
            </article>
          ))}
        </div>
      </section>
    </>
  )
}
